import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GenericError = props => {
  const getErrorConfig = () => {
    if (props.type === 'loading') {
      return {
        title: 'Loading error',
        message: 'We ran into a little trouble and could not load the details. Please try again.',
        action: props.onTryAgainClick ? /*#__PURE__*/_jsx(SectionMessageAction, {
          onClick: props.onTryAgainClick,
          children: "Try again"
        }) : undefined
      };
    } else {
      return {
        title: 'Connection error',
        message: 'Oops! Looks like something went wrong. Please check your internet connection and try again'
      };
    }
  };
  const errorConfig = getErrorConfig();
  return /*#__PURE__*/_jsxs(SectionMessage, {
    title: errorConfig.title,
    appearance: "error",
    children: [/*#__PURE__*/_jsx("p", {
      children: errorConfig.message
    }), errorConfig.action]
  });
};